import {ICoachingValue} from '../CoachingFormContainer/interfaces';
import {INormalizedDomain} from './dashboard/dashboardSlice';

export const getStatus = (
  value: ICoachingValue,
  actionAlertAttachedStatus,
  statusTypes: INormalizedDomain<any>,
  statuses: INormalizedDomain<any>,
  byName: boolean = false
) => {

  
  let statusId = 3;
  let statusName = '';

  // action alert status has preference over regular status
  let lookUpKeyword = '';

  if (
    actionAlertAttachedStatus &&
    actionAlertAttachedStatus.hasOwnProperty(value.id)
    ) {
    if (actionAlertAttachedStatus[value.id].includes('New')) {
      lookUpKeyword = 'new';
    }
    if (
      !lookUpKeyword &&
      actionAlertAttachedStatus[value.id].includes('Pending')
    ) {
      lookUpKeyword = 'pending';
    }
    if (
      !lookUpKeyword &&
      actionAlertAttachedStatus[value.id].includes('Resolved')
    ) {
      lookUpKeyword = 'resolved';
    }
    if (
      !lookUpKeyword &&
      actionAlertAttachedStatus[value.id].includes('No Action Needed')
    ) {
      lookUpKeyword = 'no action needed';
    }
    if (
      !lookUpKeyword &&
      (actionAlertAttachedStatus[value.id].includes('N/A') ||
        actionAlertAttachedStatus[value.id].includes('n/a'))
    ) {
      lookUpKeyword = 'n/a';
    }
    if (lookUpKeyword.length) {
      statusId = statusTypes.byId[lookUpKeyword].id;
      statusName = statusTypes.byId[lookUpKeyword].status;
    }
    if (!lookUpKeyword && Object.keys(statuses.byId).length > 0) {
      let status 
      if (statuses.byId[value.id]) {
        status = statuses.byId[value.id].id;
      }

      statusId = status ? status : value.ai === '1' ? 0 : 3;
      statusName = status
        ? statuses.byId[value.id].status
        : value.ai === '1'
        ? 'New'
        : 'Pending';

    }
  } else {
    // if not in the array of AA Status, then look for it in the legacy status update
    if (statuses.byId[value.id]) {
      const status = statuses.byId[value.id].id;
      statusId = status ? status : value.status;
      // statusId = status ? status : value.ai === '1' ? 0 : 3;
      statusName = status
        ? statuses.byId[value.id].status
        : value.ai === '0'
        ? 'New'
        : 'Pending';
    }
  }
  return byName ? statusName : statusId;
};

export const surveysFilterFunction = (dashboard, individualSurveysFilters, individualSurveysStatusFilter) => (individualSurvey) => {
  const isRead = individualSurvey.viewed.toLowerCase() === 'yes';
  const isActionItem = individualSurvey.ai === '1';
  const isSalesOpportunity = individualSurvey.is_sales_opportunity === 1;
  const isAttritionRisk = individualSurvey.is_attrition_risk === 1;
  const isWow = individualSurvey.wow === '1';
  const hasComments = individualSurvey.hasComments;
  const hasPerfectScore = individualSurvey.ps === '1';
  const isFlagged = individualSurvey.is_flagged === true;
  const status = getStatus(
    individualSurvey,
    dashboard.actionAlertsAttachedStatus,
    dashboard.normalizedStatusTypes,
    dashboard.legacyStatuses,
  );

  if (individualSurveysFilters.readFilter && !isRead) {
    return false;
  }
  if (individualSurveysFilters.unReadFilter && isRead) {
    return false;
  }
  if (individualSurveysFilters.actionItemFilter && !isActionItem) {
    return false;
  }
  if (
    individualSurveysFilters.salesOpportunityFilter &&
    !isSalesOpportunity
  ) {
    return false;
  }
  if (individualSurveysFilters.attritionRiskFilter && !isAttritionRisk) {
    return false;
  }
  if (individualSurveysFilters.notesFilter && !hasComments) {
    return false;
  }
  if (individualSurveysFilters.wowFilter && !isWow) {
    return false;
  }
  if (individualSurveysFilters.perfectScoreFilter && !hasPerfectScore) {
    return false;
  }
  if (individualSurveysFilters.flagFilter && !isFlagged) {
      return false;
  }
  return !(individualSurveysStatusFilter.length &&
    individualSurveysStatusFilter.indexOf(status) === -1);
};
